import axios from 'axios'
import { UserProfileData } from '../../types/userProfile/userProfileData'
import { useAidaSessionStore } from '../../stores/aidaSessionStore'
import type { authSignInCallbackResponse } from '../../types/auth/authSignInCallbackResponse'

export async function signInCallbackAsync(
  user: UserProfileData
): Promise<authSignInCallbackResponse> {
  const aidaSessionStore = useAidaSessionStore()

  try {
    const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL
    const payload = {
      idToken: user.idToken,
      client_name: aidaSessionStore.aidaClientName,
      provider: user.authProvider,
      refresh_token: user.refreshToken,
    }
    const headers = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    const url = `${BACKEND_BASE_URL}/user/logged-in`
    const response = await axios.post(url, payload, headers)

    if (response.status === 200) {
      console.log('Backend callback success')
      return (await response.data) as authSignInCallbackResponse
    }
    throw new Error(`Error in callback status code: ${response.status}`)
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const status = err.response?.status
      const backendMsg = err.response?.data?.message || err.message || 'Unknown backend error'

      console.error('Backend callback failed:', backendMsg)

      throw new Error(
        status
          ? `Backend responded with status ${status}: ${backendMsg}`
          : `Network or Axios error: ${backendMsg}`
      )
    }
    console.error('Error while callback:', err.message || err)
    throw new Error(`Error while callback: ${err.message || 'Unknown error'}`)
  }
}
